import {charcoal} from '../sass/base/_exports.sass';

export const SmsLineIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.9 4H25.1C26.1343 4 27.1263 4.39925 27.8577 5.10991C28.5891 5.82058 29 6.78444 29 7.78947V20.4211C29 21.4261 28.5891 22.3899 27.8577 23.1006C27.1263 23.8113 26.1343 24.2105 25.1 24.2105H11.515C11.2641 24.2011 11.0158 24.2626 10.8 24.3874L4.963 27.8232C4.76234 27.9389 4.53333 27.9999 4.3 28C4.07668 27.9993 3.85729 27.9428 3.663 27.8358C3.46219 27.7261 3.29499 27.5666 3.17849 27.3735C3.062 27.1804 3.0004 26.9607 3 26.7368V7.78947C3 6.78444 3.41089 5.82058 4.14228 5.10991C4.87368 4.39925 5.86566 4 6.9 4ZM26.0192 21.3142C26.263 21.0774 26.4 20.7561 26.4 20.4211V7.78947C26.4 7.45446 26.263 7.13317 26.0192 6.89629C25.7754 6.6594 25.4448 6.52632 25.1 6.52632H6.9C6.55522 6.52632 6.22456 6.6594 5.98076 6.89629C5.73696 7.13317 5.6 7.45446 5.6 7.78947V24.5011L9.5 22.2274C10.1083 21.8715 10.805 21.6837 11.515 21.6842H25.1C25.4448 21.6842 25.7754 21.5511 26.0192 21.3142ZM10.8 15.3684C11.518 15.3684 12.1 14.8029 12.1 14.1052C12.1 13.4076 11.518 12.8421 10.8 12.8421C10.082 12.8421 9.5 13.4076 9.5 14.1052C9.5 14.8029 10.082 15.3684 10.8 15.3684ZM17.3 14.1052C17.3 14.8029 16.718 15.3684 16 15.3684C15.282 15.3684 14.7 14.8029 14.7 14.1052C14.7 13.4076 15.282 12.8421 16 12.8421C16.718 12.8421 17.3 13.4076 17.3 14.1052ZM22.5 14.1052C22.5 14.8029 21.918 15.3684 21.2 15.3684C20.482 15.3684 19.9 14.8029 19.9 14.1052C19.9 13.4076 20.482 12.8421 21.2 12.8421C21.918 12.8421 22.5 13.4076 22.5 14.1052Z"
        fill={color}
      />
    </svg>
  );
};
